module.exports = __webpack_public_path__ + "img/box_pro_three_5.4e4f3eb0.jpg";